import CustomToast from "../../utilities/components/CustomToast";
import HttpClient from "../../utilities/functions/HttpClient";
import ServerEndpoints from "../../utilities/constants/ServerEndPoints";
import Errors from "../../utilities/constants/Errors";

/**
 * Fetch all gallery items from the backend.
 * @param {Function} setGalleryData The function to collect and set the data from the database.
 * @param {Object} params Optional query parameters for pagination/filtering.
 */
export const getAllGalleryItems = async (setGalleryData, params = {}) => {
  try {
    const response = await HttpClient.getAxiosClient().get(
      ServerEndpoints.GALLERY_ENDPOINT,
      { params },
    );
    if (response.status === 200) {
      setGalleryData(response.data);
    }
  } catch (err) {
    if (!err.response) {
      CustomToast(Errors.NETWORK_ERROR, "error");
    } else {
      switch (err.response.status) {
        case 503:
          CustomToast(Errors.SERVICE_UNAVAILABLE_ERROR, "error");
          break;
        case 404:
          // No items found, might not be an error per se
          break;
        default:
          CustomToast(Errors.API_ERROR, "error");
      }
    }
  }
};

/**
 * Retrieve a single gallery item from the database.
 * @param {number} id The gallery item's id to fetch.
 */
export const getGalleryItemById = async (id) => {
  try {
    const response = await HttpClient.getAxiosClient().get(
      `${ServerEndpoints.GALLERY_ENDPOINT}/${id}`,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (err) {
    CustomToast(Errors.API_ERROR, "error");
  }
};
